import * as React from 'react';
import { Level } from '../../classes/level';
import uniq from 'lodash/uniq';
import IAltText from '../../classes/alt-text';
declare var Modernizr;

interface ILevelSelectProps {
    venueBackgroundImage: string;
    venueSvgViewBox: string;
    venueSvgHighlightShading: string;
    venueBackgroundPaths: Array<string>;
    levels: Array<Level>;
    selectedLevelsString: string;
    hoveredLevel: number;
    onMouseOverLevel: (number) => void;
    onMouseLeaveLevel: () => void;
    onSelectVenueLevel: (number) => void;

    altText: IAltText;
    svgStrokeColor: string;
    svgStrokeWidth: number;
    svgHoverFillColor: string;
    svgSelectedFillColor: string;
    svgDefaultFillColor: string;
    svgClass: string;
}

class LevelSelectSvg extends React.PureComponent<ILevelSelectProps, any>{

    constructor(props) {
        super(props);
    }

    get selectedLevels(): Array<number> {
        return this.props.selectedLevelsString.split(',').filter(str => str.length > 0).map(str => +str);
    }

    render() {
        var highlightedLevels = uniq(this.selectedLevels.concat(this.props.hoveredLevel == null ? [] : [this.props.hoveredLevel]));

        let imageOverrideUrl = "";
        let currentLevelAlt = "";
        if (this.props.hoveredLevel != null) {
            const matchedLevel = this.props.levels.filter(lvl => lvl.levelNumber === this.props.hoveredLevel);

            if (matchedLevel.length > 0 && matchedLevel[0].imageOverrideUrl && matchedLevel[0].imageOverrideUrl.length > 0) {
                imageOverrideUrl = matchedLevel[0].imageOverrideUrl;
                currentLevelAlt = matchedLevel[0].name;
            }
        }
        else {
            const levelWithOverrideImage = this.selectedLevels.filter(level => {
                const matchedLevel = this.props.levels.filter(lvl => lvl.levelNumber === level);

                return matchedLevel.length > 0 && matchedLevel[0].imageOverrideUrl && matchedLevel[0].imageOverrideUrl.length > 0;
            });

            if (levelWithOverrideImage.length === this.selectedLevels.length) {
                const matchedLevel = this.props.levels.filter(lvl => lvl.levelNumber === levelWithOverrideImage[0]);

                if (matchedLevel.length > 0) {
                    imageOverrideUrl = matchedLevel[0].imageOverrideUrl;
                    currentLevelAlt = matchedLevel[0].name;
                }
            }
        }

        if (imageOverrideUrl.length > 0) {
            return <img src={imageOverrideUrl} alt={currentLevelAlt} />
        }

        return (
            this.props.venueBackgroundImage != null ?
                <React.Fragment>
                    <svg className="svg-defs" viewBox={this.props.venueSvgViewBox}>
                        <defs>
                            <mask id="active-levels">
                                <rect width={this.props.venueSvgViewBox.split(' ')[2]} height={this.props.venueSvgViewBox.split(' ')[3]} fill="white" />
                                {
                                    highlightedLevels.map(level => {
                                        return <path key={level.toString()} d={this.props.levels.filter(lvl => lvl.levelNumber === level)[0].levelSvgPaths[0]}
                                            fill="black" />
                                    })
                                }
                            </mask>
                        </defs>
                    </svg>
                    <svg className={this.props.svgClass} role="img" viewBox={this.props.venueSvgViewBox}
                        id="overlay">
                        <g dangerouslySetInnerHTML={{ __html: this.props.venueBackgroundImage }}>
                        </g>
                        <rect width={this.props.venueSvgViewBox.split(' ')[2]} height={this.props.venueSvgViewBox.split(' ')[3]}
                            fill={`rgba(0,0,0,${this.props.venueSvgHighlightShading == null ? ".5" : this.props.venueSvgHighlightShading})`}
                            mask={`url(#active-levels)`} />

                        {this.props.levels.map(level => {
                            return level.levelSvgPaths.map((path, index) => {
                                return <path key={index}
                                    d={path}
                                    fill="transparent"
                                    onMouseOver={() => { !level.disabled ? this.props.onMouseOverLevel(level.levelNumber) : null }}
                                    onMouseLeave={() => { !level.disabled ? this.props.onMouseLeaveLevel() : null }}
                                    data-level-id={level.levelNumber}
                                    onClick={() => !level.disabled ? this.props.onSelectVenueLevel(level) : null}></path>
                            })
                        })
                        }
                    </svg>
                </React.Fragment>
                :
                <svg aria-hidden="true" className={this.props.svgClass} viewBox={this.props.venueSvgViewBox} stroke={this.props.svgStrokeColor} strokeWidth={this.props.svgStrokeWidth}>
                    <title>{this.props.altText !== null ? this.props.altText.filtersLevelSelection : ''}</title>
                    {this.props.levels.map(level => {
                        return level.levelSvgPaths.map((path, index) => {
                            return <path key={index}
                                d={path}
                                className={level.disabled ? "level-disabled" : ""}
                                onMouseOver={() => { !level.disabled ? this.props.onMouseOverLevel(level.levelNumber) : null }}
                                onMouseLeave={() => { !level.disabled ? this.props.onMouseLeaveLevel() : null }}
                                fill={level.disabled ? "#CCC" : (this.props.hoveredLevel === level.levelNumber && !Modernizr.touchevents ?
                                    this.props.svgHoverFillColor : this.selectedLevels.indexOf(level.levelNumber) >= 0
                                        ? this.props.svgSelectedFillColor : this.props.svgDefaultFillColor)
                                }
                                data-level-id={level.levelNumber}
                                onClick={() => !level.disabled ? this.props.onSelectVenueLevel(level) : null}></path>
                        })
                    })
                    }
                    {
                        this.props.venueBackgroundPaths.map(path =>
                            <path key={path} d={path} />
                        )
                    }
                </svg>
        );
    }
}

export default LevelSelectSvg;